import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      component: () => import('@/views/layout/layout.vue'),
      children: [
        {
          path: '/',
          component: () => import('@/views/home/home.vue')
        },
        {
          path: '/product',
          name: '产品中心',
          component: () => import('@/views/product/product.vue'),
          children: [
            {
              path: 'wise',
              name: '智慧实验室管理平台',
              component: () => import('@/views/product/zhsysManagePlatform.vue')
            },
            {
              path: 'synthetical',
              name: '实验室综合管理平台',
              component: () => import('@/views/product/labManagePlatform.vue')
            },
            {
              path: 'instrument',
              name: '仪器预约共享管理系统',
              component: () => import('@/views/product/yqyuyuegxManageSystem.vue')
            },
            {
              path: 'approve',
              name: '实验室安全教育考试准入系统',
              component: () => import('@/views/product/kszhunruManageSystem.vue')
            },
            {
              path: 'inspect',
              name: '实验室安全检查管理系统',
              component: () => import('@/views/product/aqjcManageSystem.vue')
            },
            {
              path: 'reagent',
              name: '试剂耗材管理系统',
              component: () => import('@/views/product/sjhcManageSystem.vue')
            },
          ]
        },
        // {
        //   path: '/case',
        //   name: '客户案例',
        //   component: () => import('@/views/case/case.vue'),
        //   redirect: '/case/college',
        //   children: [
        //     {
        //       path: 'college',
        //       name: '高校',
        //       component: () => import('@/views/case/college.vue')
        //     },
        //     {
        //       path: 'institute',
        //       name: '科研院所',
        //       component: () => import('@/views/case/institute.vue')
        //     },
        //     {
        //       path: 'enterprise',
        //       name: '医院/企业',
        //       component: () => import('@/views/case/enterprise.vue')
        //     },
        //     {
        //       path: 'classic',
        //       name: '案例展示',
        //       component: () => import('@/views/case/classic.vue'),
        //     },
        //   ]
        // },
        {
          path: '/cooperate',
          name: '合作加盟',
          component: () => import('@/views/cooperate/cooperate.vue'),
          redirect: '/cooperate/dealer',
          children: [
            {
              path: 'dealer',
              name: '我是经销商',
              component: () => import('@/views/cooperate/comp/dealer.vue')
            },
            {
              path: 'business',
              name: '我是厂商',
              component: () => import('@/views/cooperate/comp/business.vue')
            }
          ]
        },

        {
          path: '/about',
          name: '关于我们',
          component: () => import('@/views/about/about.vue'),
          redirect: '/about/company',
          children: [
            {
              path: 'company',
              name: '公司介绍',
              component: () => import('@/views/about/comp/aboutCompany.vue')
            },
            {
              path: 'honor',
              name: '荣誉资质',
              component: () => import('@/views/about/comp/aboutHonor.vue')
            },
            {
              path: 'contact',
              name: '联系我们',
              component: () => import('@/views/about/comp/aboutContact.vue')
            },
          ]
        },
        {
          path: '/case/detail',
          name: '案例详情',
          component: () => import('@/views/case/caseDetail.vue')
        },
      ]
    }
  ]
})
router.beforeEach((to, from, next) => {
  next();
})
export default router
